import React from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import { _t } from "../../../app/i18n/i18n";
import { push, setParam } from "../api/filterUrlMaker";
import { SearchDropdown } from "./SearchDropdown";
import { SearchButton } from "./SearchButton";
import { SearchTooltip } from "./SearchTooltip";
import { features } from "app/features";

export const SearchBar = ({
  onBlur = noop,
  isVisible = true,
  isSearchButtonsVisible = true,
  isDropdownVisible = false,
  placeholder = "Company, analyst or keyword...",
  searchField = "",
  preventFormSubmit = false,
  keyword = "",
  ...props
}) => {
  return (
    <section className={`searchbar py-2 m-0 ${isVisible ? "d-flex" : "d-none"}`}>
      <InputGroup>
        <FormControl
          data-name="searchtext"
          type="search"
          value={keyword}
          placeholder={_t(placeholder)}
          onKeyDown={(e) => onKeyDown(e.key, e.target.value, searchField, e, preventFormSubmit, onBlur)}
          onBlur={onBlur}
          autoFocus
          {...props}
        />
        {isSearchButtonsVisible ? (
          <InputGroup.Append>
            <SearchButton onClick={() => onEnterKey(searchField, keyword)} />
            {isDropdownVisible && <SearchDropdown />}
          </InputGroup.Append>
        ) : null}
      </InputGroup>
      {features.showSearchTooltip && isSearchButtonsVisible && <SearchTooltip />}
    </section>
  );
};

const onKeyDown = (key, value, searchField, e, preventFormSubmit, onBlur) => {
  if (key === "Enter") {
    if (preventFormSubmit) {
      e.preventDefault();
    }
    onBlur(); // for clearing autocomplete suggestions
    onEnterKey(searchField, value); // update query string
  }
};

export const onEnterKey = (searchField, keyword) => {
  let qs = setParam(searchField, keyword);
  qs.From = 1;
  push(qs);
};

const noop = () => null;
